/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var RefundOutlineIcon = function RefundOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "m9.276 11.605-3.588 3.687L2 11.705l1.395-1.434 2.254 2.192 2.194-2.252 1.433 1.394Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.143 3.316a8.94 8.94 0 1 1-4.018 14.891l1.426-1.402a6.94 6.94 0 1 0-1.958-4.193l-1.99.194a8.942 8.942 0 0 1 6.54-9.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.152 8.272V6.939h-1.67v1.278c-.843.166-1.554.69-1.845 1.424-.49 1.236.392 2.56 1.885 2.83l1.603.292c.446.08.748.437.7.825-.055.42-.502.724-.994.67l-2.023-.215c-.458-.05-.876.229-.933.62-.057.39.268.748.726.797l.88.094v1.385h1.671v-1.253c1.197-.083 2.2-.882 2.334-1.944.142-1.116-.728-2.143-2.014-2.376l-1.603-.291c-.514-.093-.818-.55-.649-.975.135-.34.535-.551.952-.502l2 .236c.457.054.88-.22.942-.61.063-.39-.256-.751-.713-.805l-1.249-.147Z"
  }));
};
export default RefundOutlineIcon;